import React, { Component } from 'react';
import DataContext from '../App/Context/DataContext';

const withDataContext = WrappedComponent =>
	class WithContext extends Component {
		render() {
			return (
				<DataContext.Consumer>
					{dataContext => (
						<WrappedComponent {...this.props} dataContext={dataContext} />
					)}
				</DataContext.Consumer>
			);
		}
	};

export default withDataContext;
